import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as omnivore from '@mapbox/leaflet-omnivore'
import * as L from 'leaflet';
import { Route } from '../interfaces/route';
import { MapService } from '../services/map.service';
import { GlobalVariables } from '../common/global-variables';

const baseUrl: string = "https://www3.septa.org/realtime/kml/kml.php?route=";

@Injectable({
  providedIn: 'root'
})
export class KmlService {

  public map: any;
  private layers: any = L.featureGroup();

  constructor(private http: HttpClient, private mapService: MapService) { }

  get(map: L.map, route: Route, focused: boolean = true) {
    var mode = 'bus';
    var line = route.id.toUpperCase();
    if (route.mode == "Regional Rail") {
      mode = 'rail';
      line = line.toUpperCase();
    }

    if(line == 'MEDIA/WAWA'){
      line = 'MED';
    }

    if (focused) {
      var layer = omnivore.kml('https://www3.septa.org/realtime/kml/kml.php?route=' + line + '&type=' + mode)
        .on('ready', function () {
          this.options._markertype = 'kml';
          map.fitBounds(layer.getBounds());
        })
        .addTo(map);
    }
    else{
      var layer = omnivore.kml('https://www3.septa.org/realtime/kml/kml.php?route=' + line + '&type=' + mode)
        .on('ready', function () {
          this.options._markertype = 'kml';
        })
        .addTo(map);
    }

    this.layers.addLayer(layer);
  }

  set(route_id: string, focused: boolean = true) {
    var mode = 'bus';

    if (GlobalVariables.railRoutes.includes(route_id)) {
      mode = 'rail';
    }

    if (focused) {
      var layer = omnivore.kml('https://www3.septa.org/realtime/kml/kml.php?route=' + route_id + '&type=' + mode)
        .on('ready', function () {
          this.options._markertype = 'kml';
          this.mapService.map.fitBounds(layer.getBounds());
        })
        .addTo(this.mapService.map);
    }
    else{
      var layer = omnivore.kml('https://www3.septa.org/realtime/kml/kml.php?route=' + route_id + '&type=' + mode)
        .on('ready', function () {
          this.options._markertype = 'kml';
        })
        .addTo(this.mapService.map);
    }

    this.layers.addLayer(layer);
  }

  clear(map: L.map) {
    map.eachLayer(function (layer: any) {
      if (layer.options._markertype == 'kml') {
        map.removeLayer(layer);
        return true;
      }
    });
  }

  transform(route: Route): string {
    var i = route.legacy.lastIndexOf("_") + 1;
    var line: string = route.legacy.toUpperCase().substring(i);

    switch (line) {
      case 'APT':
        line = 'AIR';
        break;
      case 'FXC':
        line = 'FOX';
        break;
      case 'LANDDOY':
        line = 'LAN';
        break;
      case 'TRENT':
        line = 'TRE'
        break;
      case 'WARM':
        line = 'WAR';
        break;
      case 'WILM':
        line = 'WIL';
        break;
      case 'WTREN':
        line = 'WTR';
        break;
      case 'MEDIA/WAWA':
        line = 'MED';
    }

    return line;
  }
}
